<template>
  <div>
    <b-form-group
      v-if="!readonly || (internalValue && internalValue.length > 0)"
      :label="$t('Webportal.Comments')"
      label-size="sm"
    >
      <b-form-textarea
        v-if="!readonly"
        v-model="newCommentText"
        :placeholder="$t('Webportal.Comment.Placeholder')"
        class="app-ctrl"
        max-rows="6"
      />
    </b-form-group>
    <b-form-group v-if="!readonly">
      <b-button
        variant="secondary"
        size="sm"
        class="float-right"
        style="width: 100px"
        :disabled="!newCommentText"
        @click="sendComment"
      >
        {{ $t("Webportal.Send") }} <b-spinner v-show="isBusy" small></b-spinner>
      </b-button>
    </b-form-group>

    <b-form-group v-for="(comment, index) of internalValue" :key="index">
      <div class="row">
        <div class="col-auto align-self-start pr-0">
          <font-awesome-layers full-width class="fa-2x text-secondary">
            <font-awesome-icon icon="circle" />
            <font-awesome-layers-text
              class="col-form-label-sm btn-secondary"
              style="background-color: transparent"
              :value="
                getUserInitials(
                  comment.CreatedBy.FirstName,
                  comment.CreatedBy.LastName
                )
              "
            />
          </font-awesome-layers>
        </div>
        <div class="col">
          <span class="col-form-label-sm text-muted">
            {{ comment.CreatedBy.FirstName }}
            {{ comment.CreatedBy.LastName }}
            <span v-if="comment.CreatedBy.Email">
              ({{ comment.CreatedBy.Email }})
            </span>
            <span class="float-right">
              {{ comment.CreatedAt | msm_datetime_long }}
            </span>
          </span>
          <p>
            {{ comment.Comment }}
          </p>
        </div>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import ActionService from "@/services/ActionService";

export default {
  name: "SurveyRevisionComments",

  props: {
    surveyRevisionId: { type: Number, default: null },
    surveyRevisionEntryId: { type: Number, default: null },
    value: { type: Array, default: null },
    readonly: { type: Boolean, default: false },
  },

  data() {
    return {
      newCommentText: null,
      internalValue: this.value,

      isBusy: false,
    };
  },

  watch: {
    value(newVal, oldVal) {
      this.thresholds = newVal;
    },

    internalValue(newVal, oldVal) {
      this.$emit("input", newVal);
    },

    isBusy(newVal, oldVal) {
      this.$emit("is-busy-changed", newVal);
    },
  },

  methods: {
    getUserInitials: function (firstName, lastName) {
      if (firstName && lastName)
        return (
          firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()
        );
      else return "";
    },

    sendComment() {
      this.isBusy = true;

      let newComment = {
        SurveyRevisionId: this.surveyRevisionId,
        SurveyRevisionEntryId: this.surveyRevisionEntryId,
        Comment: this.newCommentText,
      };

      ActionService.createSurveyRevisionComment(
        this.surveyRevisionId,
        newComment
      )
        .then((response) => {
          if (!response.data) return Promise.reject();

          if (this.internalValue) this.internalValue.unshift(response.data);
          else this.internalValue = [response.data];
          this.newCommentText = null;
        })
        .catch((error) => {
          console.error(error);

          this.$bvToast.toast(
            this.$t("Webportal.SaveFailed.Text", {
              entity: this.$t("Webportal.Actions.SurveyRevisionComment"),
            }),
            {
              autoHideDelay: 5000,
              variant: "danger",
              noCloseButton: true,
            }
          );
        })
        .finally((_) => {
          this.isBusy = false;
        });
    },
  },
};
</script>
